import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, toRefs } from 'vue'
    import { createSlider } from '@typeform/embed'
    import '@typeform/embed/build/css/slider.css'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    form: null,
    hidden: null
  },
  setup(__props: any) {

const props = __props as { form: string, hidden: Record<string, string> }

    const toggle = ref<() => void>()
    const typeformElement = ref<HTMLElement>()
    const enableSandbox: boolean = process.env.VUE_APP_TYPEFORM_SANDBOX_MODE === 'true'

    
    const { form, hidden } = toRefs(props)

    onMounted(() => {
        if (typeformElement.value) {
            const typeform = createSlider(form.value, {
                container: typeformElement.value || new HTMLElement(),
                enableSandbox,
                hidden: hidden.value || {},
            })

            toggle.value = typeform.toggle
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "typeformElement",
      ref: typeformElement
    }, null, 512),
    _renderSlot(_ctx.$slots, "default", { toggle: toggle.value })
  ], 64))
}
}

})